import {radToDeg} from '../components/visual/olivio3d-utils';


class OlivioLayout {
	static conf = {};

	// to be overridden
	calculateLimits(design, configValues) {
		return {};
	}

	// to be overridden
	calculate(configValues) {
		return [];
	}

	getConfValue(name, keys = []) {
		const conf = this.constructor.conf;
		let value = name in conf ? conf[name] : null;
		let parent = conf;
		for (const key of keys) {
			if (key in parent) {
				if (name in parent[key]) {
					value = parent[key][name];
				}
				parent = parent[key];
			} else {
				break;
			}
		}
		return value;
	}

}

export {OlivioLayout};
